var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveSideIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 31,
    viewBox: "0 0 3 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.523926L1.20092 1.5247C2.34089 2.47466 3 3.8819 3 5.3658V25.682C3 27.1659 2.34088 28.5732 1.20092 29.5232L0 30.5239V0.523926Z",
    fill: "#1CA0A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveSideIcon);
export default __webpack_public_path__ + "static/media/activeSideIcon.14efcf87cf505dea665c0eeedc4e447a.svg";
export { ForwardRef as ReactComponent };